<template>
  <AppDrawer
    v-model="open"
    :title="t('promo.vip.rules.title')"
    padded
    body-padding="14px 14px 48px"
    @back="emit('close')"
  >
    <div class="sub-body">
      <div class="section" style="margin-top: 0px">
        <div class="act-block-t">{{ t('promo.vip.rules.levelAndUpgradeTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.vip.rules.levelAndUpgrade1')" />
          <li
            v-html="
              t('promo.vip.rules.levelAndUpgrade2', { amount18: fmt(1350), amount50: fmt(17664) })
            "
          />
          <li v-html="t('promo.vip.rules.levelAndUpgrade3')" />
        </ul>
      </div>
      <div class="section">
        <div class="act-block-t">{{ t('promo.vip.rules.retentionTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.vip.rules.retention1')" />
          <li v-html="t('promo.vip.rules.retention2', { amount1: fmt(450), amount2: fmt(4500) })" />
          <li v-html="t('promo.vip.rules.retention3')" />
        </ul>
      </div>
      <div class="section">
        <div class="act-block-t">{{ t('promo.vip.rules.paymentTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.vip.rules.payment1', { note: siteClockNote() })" />
          <li v-html="t('promo.vip.rules.payment2', { note: siteClockNote(0, 0, false) })" />
          <li v-html="t('promo.vip.rules.payment3', { note: siteClockNote(0, 0, false) })" />
          <li v-html="t('promo.vip.rules.payment4')" />
        </ul>
      </div>
      <div class="section">
        <div class="act-block-t">{{ t('promo.vip.rules.claimTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.vip.rules.claim1')" />
          <li v-html="t('promo.vip.rules.claim2')" />
          <li v-html="t('promo.vip.rules.claim3')" />
        </ul>
      </div>
    </div>
  </AppDrawer>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/user'
import { formatBaseAmt } from '~/utils/transfer/money'
import AppDrawer from '~/components/AppDrawer.vue'

const userStore = useUserStore()
const fmt = (n: number) => formatBaseAmt(n, userStore.baseCurrency)
const { t } = useI18n()
// 俸禄按站点日界刷新：规则里写明站点时间，设备时区不同时补当地钟点
const { siteClockNote } = useSiteContext()

const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  close: []
}>()

const open = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<style scoped lang="scss">
.section {
  margin-top: 18px;
}

.act-block-t {
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  margin: 0 2px 10px;
  padding-left: 9px;
  border-left: 3px solid var(--primary);
}

.act-terms {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    padding: 0 0 9px 15px;
    font-size: 12.5px;
    line-height: 1.6;
    color: var(--muted);
  }

  li::before {
    content: '';
    position: absolute;
    left: 2px;
    top: 8px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--primary);
  }
}
</style>
